'use client';
import { useState, useEffect, useRef, useMemo } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
} from '@chakra-ui/react';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Select from 'react-select';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import DynamicFilterall from '../components/DynamicFilterall';
// import { getCompanies } from '../../../../redux/actions/company';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getItemByContactReport } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
// import { columnsReportsPurchaseDetail } from 'views/admin/customDataTable/variables/columnsData';
import DynamicFilterAllHorizontal from '../components/DynamicFilterAllHorizontal';
import { getItem } from '../../../../redux/actions/item';
import { useGlobal } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { useUser } from 'contexts';

const ItembyContact = () => {
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const { companyList } = useGlobal();
   // const company = useSelector((state) => state.company.list || []);
   const itemList = useSelector((state) => state.item.list || []);
   const { user } = useUser();
   const dbName = localStorage.getItem('dbName');
   const fromDateInputRef = useRef(null);
   const lastKeyPressed = useRef('');
   const keyPressTimeoutRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [companyFilter, setCompanyFilter] = useState([]);
   const [fromDate, setFromDate] = useState(null);
   const [itemId, setItemId] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const columnsReportsLedgerDetail = [
      {
         id: 'date',
         header: 'Date',
         accessor: 'date',
      },
      {
         id: 'docnumber',
         header: 'Doc No',
         accessor: 'docnumber',
      },
      {
         id: 'daybookname',
         header: 'Daybook',
         accessor: 'daybookname',
      },
      {
         id: 'daybookaccountname',
         header: 'ContraAccount',
         accessor: 'daybookaccountname',
      },
      {
         id: 'particulars',
         header: 'Particulars',
         accessor: 'particulars',
      },
      {
         id: 'accountname',
         header: 'Contact',
         accessor: 'accountname',
      },
      {
         id: 'transactionAt',
         header: 'TransactionAt',
         accessor: 'transactionAt',
      },
   ];

   const dispatch = useDispatch();
   const Ledger = useSelector((state) => state.reports.itemByContact || []);
   const [expandedItems, setExpandedItems] = useState({});
   useEffect(() => {
      if (Ledger && Ledger.length > 0) {
         const initialExpandedState = {};

         // Set all companies and accounts to expanded by default
         Ledger.forEach((company) => {
            initialExpandedState[`company-${company.companyId}`] = true;

            if (company.accounts && company.accounts.length > 0) {
               company.accounts.forEach((account) => {
                  initialExpandedState[`account-${account.accountId}`] = true;
               });
            }
         });

         setExpandedItems(initialExpandedState);
      }
   }, [Ledger]);

   const toggleExpand = (id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   };
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   const itemOptions = useMemo(() => {
      return itemList.map((account) => ({
         value: account.id,
         label: account.name,
      }));
   }, [itemList]);
   useEffect(() => {
      // dispatch(getCompanies()); // Fetch companies when the component mounts
      dispatch(getItem({companyId : user.loginhistory.companyId,}));
   }, [dispatch]);

   useEffect(() => {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1);
      const formattedDate = today.toISOString().split('T')[0];
      setFromDate(formattedDate);
   }, []);

   const [DateFilter, setDateFilter] = useState(''); // State to store selected value

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList?.length > 0) {
         const companyId = parseInt(storedCompanyId);
         // Find the company in the company list that matches the stored ID
         const matchingCompany = companyList?.find((comp) => comp.id === companyId);

         if (matchingCompany) {
            // Create an option object for react-select
            // const option = { value: matchingCompany.id, label: matchingCompany.name };
            // Update the company filter state
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      const companyIds =
         companyFilter.length > 0
            ? companyFilter // This already contains the company IDs
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      if (itemId && fromDate && toDate) {
         dispatch(
            getItemByContactReport({
               fromDate,
               toDate,
               companyIds: companyIds.toString(),
               // accIds: itemId,
               orderBy: 'asc',
            }),
         );
      }
      // }
   }, [DateFilter, dispatch, companyFilter, fromDate, toDate, itemId]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   useEffect(() => {
      // Function to handle keyboard shortcuts
      const handleKeyDown = (e) => {
         // Track "." key presses to detect ".." sequence
         if (e.key === '.') {
            // If this is the second "." within a short timeframe
            if (lastKeyPressed.current === '.' && keyPressTimeoutRef.current) {
               // Get today's date for toDate
               const today = new Date();
               const todayFormatted = today.toISOString().split('T')[0];

               // Set toDate to today
               setToDate(todayFormatted);

               // Get first day of current month for fromDate
               const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
               const firstDayFormatted = firstDay.toISOString().split('T')[0];

               // Set fromDate to first day of current month
               setFromDate(firstDayFormatted);

               // Clear the timeout and reset
               clearTimeout(keyPressTimeoutRef.current);
               keyPressTimeoutRef.current = null;
               lastKeyPressed.current = '';
            } else {
               // First "." press - start tracking for second press
               lastKeyPressed.current = '.';

               // Clear any existing timeout
               if (keyPressTimeoutRef.current) {
                  clearTimeout(keyPressTimeoutRef.current);
               }

               // Set timeout to reset if second "." doesn't come quickly
               keyPressTimeoutRef.current = setTimeout(() => {
                  lastKeyPressed.current = '';
                  keyPressTimeoutRef.current = null;
               }, 500); // 500ms window to press the second "."
            }
         } else {
            // Different key pressed - reset
            lastKeyPressed.current = '';
            if (keyPressTimeoutRef.current) {
               clearTimeout(keyPressTimeoutRef.current);
               keyPressTimeoutRef.current = null;
            }
         }
      };

      // Add event listener directly to document
      document.addEventListener('keydown', handleKeyDown);

      // Clean up the event listener when component unmounts
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
         if (keyPressTimeoutRef.current) {
            clearTimeout(keyPressTimeoutRef.current);
         }
      };
   }, []);

   const generateLast40Months = () => {
      const months = [];
      const currentDate = new Date();
      for (let i = 0; i < 40; i++) {
         const year = currentDate.getFullYear();
         const month = currentDate.toLocaleString('en-US', { month: 'short' }); // Example: "Feb"

         months.push(`${month} ${year}`);

         // Move to the previous month
         currentDate.setMonth(currentDate.getMonth() - 1);
      }
      return months;
   };

   // const compOptions = ["comp update", "Long Best Co", "SS WEB CREATION", "TEST COMPANY NAME"];
   const secondOptions = generateLast40Months();
   const Groupby = ['contact', 'None'];
   const TransactionType = ['All', 'Purchase invoice', 'Credit note', 'Debit note'];
   const TaxType = ['All', 'Tax', 'NoTax']; // State to store selected value

   const [TransactionTypeFilter, setTransactionTypeFilter] = useState(''); // State to store selected
   const [GroupbyFilter, setGroupbyFilter] = useState(''); // State to store selected value
   const [TaxTypeFilter, setTaxTypeFilter] = useState(''); // State to store selected value
   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };
   const handleItemChange = (selectedOption) => {
      setItemId(selectedOption ? selectedOption.value : null);
   };

   // const [selectedFilters, setSelectedFilters] = useState({});
   const selectedFilters = {
      // Company: companyFilter,
      Date: DateFilter,
      'Tax Type': TaxTypeFilter,
      'Group by': GroupbyFilter,
      'Txn Type': TransactionTypeFilter,
   };

   const removeFilter = (filterKey) => {
      switch (filterKey) {
         case 'Company':
            setCompanyFilter([]);
            break;
         case 'Date':
            setDateFilter(null);
            break;
         case 'Tax Type':
            setTaxTypeFilter('');
            break;
         case 'Group by':
            setGroupbyFilter('');
            break;
         case 'Txn Type':
            setTransactionTypeFilter('');
            break;
         default:
            break;
      }
   };

   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsReportsLedgerDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const columns = columnsReportsLedgerDetail
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color="gray.400">
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );
   // Format date to a readable format

   const renderDataRows = (rowData) => {
      return rowData.map((row, index) => (
         <Tr key={`row-${row.docid || index}`} _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}>
            <Td p="2px" py="3px" fontSize="14px">
               {row.date.toString()}
            </Td>
            <Td p="2px" py="3px" fontSize="14px">
               {row.docnumber || '-'}
            </Td>
            <Td p="2px" py="3px" fontSize="14px">
               {row.daybookname || '-'}
            </Td>
            <Td p="2px" py="3px" fontSize="14px">
               {row.daybookaccountname || '-'}
            </Td>
            <Td p="2px" py="3px" fontSize="14px">
               {row.particulars || '-'}
            </Td>
            <Td p="2px" py="3px" fontSize="14px" isNumeric>
               {row.txnType === 1 ? Math.abs(row.amount) : '-'}
            </Td>
            <Td fontSize="14px" isNumeric>
               {row.txnType === 0 ? Math.abs(row.amount) : '-'}
            </Td>
            <Td fontSize="14px" isNumeric>
               {(() => {
                  const absBal = Math.abs(row.bal).toFixed(2);
                  const [intPart, decimalPart] = absBal.split('.');
                  return (
                     <Box display="flex" justifyContent="flex-end" gap="1px" whiteSpace="nowrap">
                        <Text>{intPart}</Text>
                        <Text fontSize="10px" mt={0.5} color="gray.400">
                           {' '}
                           . {decimalPart}
                        </Text>
                        <Text>
                           {'\u00A0'}
                           {row.bal < 0 ? 'DB' : 'CR'}
                        </Text>
                     </Box>
                  );
               })()}
            </Td>
         </Tr>
      ));
   };

   return (
      <>
         {/* Title Outside Card */}

         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Item by Contact
               </Text>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent="end">
               <Flex flex="" gap={2} mr={3}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        fontWeight={500}
                        mt={5}
                        display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Flex>
               <Flex flex="" gap={2} mr={3}>
                  <Box my={2} width="300px" fontSize={'13px'} display={{ base: 'none', xl: 'block' }} fontWeight={500}>
                     <label>Item</label>

                     <Select
                        placeholder="Select Item"
                        name="itemId"
                        options={itemOptions}
                        onChange={handleItemChange}
                        value={itemOptions.find((option) => option.value === itemId)} // Set the selected value
                        isMulti={true}
                        isClearable
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           // input: (baseStyles) => ({
                           //   ...baseStyles,
                           //   margin: '0',
                           //   padding: '0'
                           // })
                        }}
                     />
                  </Box>
               </Flex>
               <Flex flex="2">
                  <Box
                     my={2}
                     mr={3}
                     fontSize={'13px'}
                     display={{ base: 'none', xl: 'block' }}
                     fontWeight={500}
                     w={'180px'}>
                     <label>From Date</label>
                     <Input
                        type="date"
                        value={fromDate || ''}
                        onChange={(e) => setFromDate(e.target.value)}
                        ref={fromDateInputRef}
                        w={'180px'}
                        h={'30px'}
                     />
                  </Box>
                  <Box my={2} fontSize={'13px'} display={{ base: 'none', xl: 'block' }} fontWeight={500} w={'180px'}>
                     <label>To Date</label>
                     <Input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        w={'180px'}
                        h={'30px'}
                     />
                  </Box>
               </Flex>
               <Flex className="flex flex-wrap gap-2">
                  {DateFilter.length > 0 && (
                     <>
                        {Object.entries({
                           Company: companyFilter,
                           Date: DateFilter,
                        })
                           .filter(([_, value]) => value && value.length > 0) // Ensure it only displays active filters
                           .map(([key, value]) => (
                              <Flex
                                 key={key}
                                 style={{
                                    border: '1px solid gray',
                                    borderRadius: '10px',
                                    marginLeft: 10,
                                    paddingLeft: 4,
                                 }}>
                                 <span>
                                    {key} :{' '}
                                    {key === 'Company'
                                       ? companyOptions
                                            .filter((opt) => value.includes(opt.value))
                                            .map((opt) => opt.label)
                                            .join(', ')
                                       : value}
                                 </span>
                                 <Image
                                    src={cancel}
                                    alt="Cancel"
                                    width={3}
                                    ml={3}
                                    mr={2}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => removeFilter(key)}
                                 />
                              </Flex>
                           ))}
                     </>
                  )}
                  {(DateFilter || TaxTypeFilter || GroupbyFilter || TransactionTypeFilter) && (
                     <Flex className="flex flex-wrap gap-2">
                        {Object.entries(selectedFilters)
                           .filter(([_, value]) => value) // Only display filters with values
                           .map(([key, value]) => (
                              <Flex
                                 key={key}
                                 style={{
                                    border: '1px solid gray',
                                    borderRadius: '10px',
                                    marginLeft: 10,
                                    paddingLeft: 4,
                                 }}>
                                 <span className="mr-2">
                                    {key} : {value}
                                 </span>
                                 <Image
                                    src={cancel}
                                    alt="Cancel"
                                    width={3}
                                    ml={3}
                                    mr={2}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => removeFilter(key)}
                                 />
                              </Flex>
                              // <Flex key={key} className="flex items-center bg-gray-200 px-3 py-1 rounded-full text-sm" px={4} py={2} style={{ border: "1px solid", borderRadius: "10px", marginLeft: "10px" }}>
                              //   <span className="mr-2">{key} : {value}</span>
                              //   <Image
                              //     src={cancel}
                              //     alt="Cancel"
                              //     width={4}
                              //     ml={5}
                              //     style={{ cursor: "pointer" }}
                              //     // className="ml-2 cursor-pointer"
                              //     onClick={() => removeFilter(key)}
                              //   />
                              // </Flex>
                           ))}
                     </Flex>
                  )}
                  <Flex>
                     <Popover>
                        <PopoverTrigger>
                           {/* Image as Clickable Button */}
                           <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                        </PopoverTrigger>

                        <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                           <PopoverBody p="3">
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={() => alert('Option 1 Selected')}
                                 justifyContent="space-between"
                                 mb={3}>
                                 <img src={xls} alt="Download XLS" width="30px"></img>
                                 Download Execl
                              </Button>
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={() => alert('Option 2 Selected')}
                                 justifyContent="space-between">
                                 <img src={json} alt="Download json" width="30px" mr></img>
                                 Download JSON
                              </Button>
                           </PopoverBody>
                        </PopoverContent>
                     </Popover>
                  </Flex>
                  <Flex ml={5}>
                     <Box>
                        {/* <DynamicFilterall
                           filters={[
                              {
                                 name: 'Date',
                                 options: secondOptions.map((month) => month),
                                 defaultText: 'Select Date',
                                 type: 'date',
                                 onSelect: (val) => setDateFilter(val),
                              },
                              {
                                 name: 'Txn Type',
                                 options: TransactionType,
                                 defaultText: 'Txn Type',
                                 onSelect: (val) => setTransactionTypeFilter(val),
                              },
                              {
                                 name: 'Group by',
                                 options: Groupby,
                                 defaultText: 'Group by',
                                 onSelect: (val) => setGroupbyFilter(val),
                              },
                              {
                                 name: 'Tax Type',
                                 options: TaxType,
                                 defaultText: 'Tax Type',
                                 onSelect: (val) => setTaxTypeFilter(val),
                              },
                           ]}
                        /> */}
                     </Box>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter, // Filter based on companyFilter values
                                 onChange: handleCompanyChange, // Handle change
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true, // isSearchable
                              undefined, // filteredOptions (optional, can be null or undefined)
                              true, // isMulti
                           )}
                        </GridItem>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Item</label>
                           <Select
                              placeholder="Select Item"
                              name="itemId"
                              options={itemOptions}
                              onChange={handleItemChange}
                              value={itemOptions.find((option) => option.value === itemId)} // Set the selected value
                              isMulti={true}
                              isClearable
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                                 // input: (baseStyles) => ({
                                 //   ...baseStyles,
                                 //   margin: '0',
                                 //   padding: '0'
                                 // })
                              }}
                           />
                        </Box>

                        <Box my={2} fontSize="13px" fontWeight={500}>
                           <label>From Date</label>
                           <Input
                              type="date"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                              w="100%"
                              h="40px"
                              mb={3}
                           />
                        </Box>

                        <Box my={2} fontSize="13px" fontWeight={500}>
                           <label>To Date</label>
                           <Input
                              type="date"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                              w="100%"
                              h="40px"
                              mb={3}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>
                        {Ledger.length === 0 ? (
                           <Tr>
                              <Td colSpan={columns.length} textAlign="center" py="40px">
                                 <Text>No data found</Text>
                              </Td>
                           </Tr>
                        ) : (
                           Ledger.map((companyData, companyIndex) => (
                              <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
                                 {/* Company Level Row */}
                                 <Tr
                                    bg="purple.50"
                                    _dark={{ bg: 'purple.900' }}
                                    cursor="pointer"
                                    onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
                                    <Td colSpan={columns.length + 1} p="5px">
                                       <Flex justifyContent="space-between" alignItems="center">
                                          <Text fontWeight="bold" fontSize="14px">
                                             {companyData.companyName}
                                          </Text>
                                          {expandedItems[`company-${companyData.companyId}`] ? (
                                             <ChevronUpIcon size={20} />
                                          ) : (
                                             <ChevronDownIcon size={20} />
                                          )}
                                       </Flex>
                                    </Td>
                                 </Tr>

                                 {expandedItems[`company-${companyData.companyId}`] &&
                                    companyData.accounts &&
                                    companyData.accounts.map((accountData, accountIndex) => (
                                       <React.Fragment key={`account-${accountData.accountId || accountIndex}`}>
                                          {/* Account Level Row */}
                                          <Tr
                                             bg="blue.50"
                                             _dark={{ bg: 'blue.900' }}
                                             cursor="pointer"
                                             onClick={() => toggleExpand(`account-${accountData.accountId}`)}>
                                             <Td colSpan={columns.length + 1} p="5px" pl="30px">
                                                <Flex justifyContent="space-between" alignItems="center">
                                                   <Flex>
                                                      <Text fontWeight="semibold" fontSize="12px">
                                                         {accountData.accountName}
                                                      </Text>
                                                      <Text fontSize="12px" ml={4} color="gray.600">
                                                         Opening Balance:{' '}
                                                         {accountData.openingBalance >= 0
                                                            ? `₹${accountData.openingBalance.toLocaleString()} CR`
                                                            : `₹${Math.abs(
                                                                 accountData.openingBalance,
                                                              ).toLocaleString()} DB`}
                                                      </Text>
                                                   </Flex>
                                                   {expandedItems[`account-${accountData.accountId}`] ? (
                                                      <ChevronUpIcon size={18} />
                                                   ) : (
                                                      <ChevronDownIcon size={18} />
                                                   )}
                                                </Flex>
                                             </Td>
                                          </Tr>

                                          {/* Account Headers & Data */}
                                          {expandedItems[`account-${accountData.accountId}`] && (
                                             <>
                                                <Tr bg="gray.50" _dark={{ bg: 'gray.800' }}>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold">
                                                      Date
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold">
                                                      Doc#
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold">
                                                      Daybook
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold">
                                                      ContraAccount
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold">
                                                      Particulars
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold" isNumeric>
                                                      Debit
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold" isNumeric>
                                                      Credit
                                                   </Td>
                                                   <Td p="2px" py="3px" fontSize="12px" fontWeight="bold" isNumeric>
                                                      Balance
                                                   </Td>
                                                </Tr>
                                                {accountData.data &&
                                                   Array.isArray(accountData.data) &&
                                                   renderDataRows(accountData.data)}
                                                {accountData.data && Array.isArray(accountData.data) && (
                                                   <Tr bg="gray.100" _dark={{ bg: 'gray.700' }}>
                                                      <Td
                                                         colSpan={5}
                                                         textAlign="right"
                                                         fontSize="14px"
                                                         fontWeight="bold">
                                                         Account Total:
                                                      </Td>
                                                      <Td fontWeight="bold" fontSize="14px" isNumeric>
                                                         {accountData.data
                                                            .filter((row) => row.txnType === 1)
                                                            .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                                                            .toLocaleString()}
                                                      </Td>
                                                      <Td fontWeight="bold" fontSize="14px" isNumeric>
                                                         {accountData.data
                                                            .filter((row) => row.txnType === 0)
                                                            .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                                                            .toLocaleString()}
                                                      </Td>
                                                      <Td fontWeight="bold" fontSize="14px" isNumeric>
                                                         {/* Display closing balance based on the last entry */}
                                                         {accountData.data.length > 0
                                                            ? `${Math.abs(
                                                                 accountData.data[accountData.data.length - 1].bal,
                                                              ).toLocaleString()} 
                                                          ${
                                                             accountData.data[accountData.data.length - 1].bal < 0
                                                                ? 'DB'
                                                                : 'CR'
                                                          }`
                                                            : `${Math.abs(accountData.openingBalance).toLocaleString()} 
                                                          ${accountData.openingBalance < 0 ? 'DB' : 'CR'}`}
                                                      </Td>
                                                   </Tr>
                                                )}
                                             </>
                                          )}
                                       </React.Fragment>
                                    ))}
                              </React.Fragment>
                           ))
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>
      </>
   );
};

export default ItembyContact;
